/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WindowSize } from '../WindowSize.js';
import { useNavigate } from 'react-router-dom';
import { GetUrl, CTicksToDateString, formatNumber } from '../Utility.js';

import Title from './Title.js';
import DetailModalType1 from './DetailModalType1.js'
import WriteModalType from './WriteModalType.js'

function FAQ() {
  const state=useSelector((state)=>state);
  const dispatch = useDispatch();
  const navigate = useNavigate(); 

  const [pageIndex, setpageIndex] = useState(0); // 선택된 드롭다운 항목
  const [totalCount, setTotalCount] = useState(0); // 선택된 드롭다운 항목
  const [viewIndex, setviewIndex] = useState(0); // 선택된 드롭다운 항목

  function GetPageNumber(number)
  {
    return (pageIndex * 10) + number;
  }

  function NextPage()
  {
    if(totalCount === 0)
    {
        return;
    }

    var maxIndex = Math.ceil(totalCount / 15);
    if(viewIndex === maxIndex)
    {
        return;
    }

    var newViewIndex = viewIndex + 1;
    ClickViewIndex(newViewIndex);  
    setpageIndex(Math.floor((newViewIndex - 1) / 15));
  }

  function PrevPage()
  {
    if(totalCount === 0 ||
        viewIndex === 1)
    {
        return;
    }

    var newViewIndex = viewIndex - 1;
    ClickViewIndex(newViewIndex);
    setpageIndex(Math.floor((newViewIndex - 1) / 15));
  }

  function ClickViewIndex(index)
  {
    if(totalCount === 0)
    {
        return;
    }
    
    if(state.Request === 1)
    {
        return;
    }
    
    if(viewIndex === index)
    {
        return;
    }

    var maxIndex = Math.ceil(totalCount / 15);
    if(maxIndex < index)
    {
        return;
    }

    setviewIndex(index);
    RequestFAQSearch(index);
  }

    const RequestFAQSearch = async (index) => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
                alert('유저 정보 만료(다시 로그인 해주세요)');  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                return;    
            }
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'Admin/AdminGetFAQList', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey, start_index : index - 1, content_count : 15}),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    dispatch({type:'UpdateFAQArray', Log:data.data_array});  
                    setTotalCount(data.total_count);
                }
                else if(data.result === 14 ||
                        data.result === 16)
                {
                    alert('존재 하지 않는 티켓 입니다');  
                }
                else if(data.result === 15)
                {
                    alert('이미 사용한 티켓 입니다');  
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                var startTime = CTicksToDateString(data.start_time);
                var endTime = CTicksToDateString(data.end_time);

                var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                alert(message);  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };

    function GetFAQNo(index)
    {
        if(state.FAQArray === undefined || state.FAQArray.length <= index)
        {
            return "";
        }

        var convertIndex = ((viewIndex - 1) * 10) + index;
        if(totalCount <= convertIndex)
        {
            return'';
        }

        return convertIndex + 1;
    }

    function GetFAQTitle(index)
    {
        if(state.FAQArray === undefined || state.FAQArray.length <= index)
        {
            return "";
        }

        return state.FAQArray[index].title;
    }

    function GetFAQRegisterTime(index)
    {
        if(state.FAQArray === undefined || state.FAQArray.length <= index)
        {
            return "";
        }

        return CTicksToDateString(state.FAQArray[index].create_at_time);
    }

    function GetFAQClick(index)
    {
        if(state.FAQArray === undefined || state.FAQArray.length <= index)
        {
            return false;
        }

        return true;
    }

    function FAQClick(index)
    {
        if(state.FAQArray === undefined || state.FAQArray.length <= index)
        {
            return;
        }

        dispatch({type:'UpdateDetailModalType1', View:true, Type:3, No:state.FAQArray[index].no});
    }

    function Reset()
    {
        setpageIndex(0);
        setTotalCount(0);
        setviewIndex(1);
        RequestFAQSearch(1);
    }

    const RequestDelete = async (index) => 
    {
        if(window.confirm(state.FAQArray[index].title + " 정말로 삭제 하시겠습니까?")) {
            try
            {
                if(state.Request === 1)
                {
                    return;
                }
    
                var secretkey = sessionStorage.getItem("secret_key");
                if(secretkey === null)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                    return;    
                }
                
                dispatch({type:'Request'});
                const response = await fetch(GetUrl() + 'Admin/AdminDeleteFAQ', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secret_key : secretkey, no : state.FAQArray[index].no}),
                });
    
                if (response.ok) {
                    const data = await response.json();
                    if(data.result === 0)
                    {
                    }
                    else if(data.result === 14 ||
                            data.result === 16)
                    {
                        alert('존재 하지 않는 티켓 입니다');  
                    }
                    else if(data.result === 15)
                    {
                        alert('이미 사용한 티켓 입니다');  
                    }
                    else if(data.result === 3 ||
                            data.result === 1)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 21) // 점검 중
                    {
                        var startTime = CTicksToDateString(data.start_time);
                        var endTime = CTicksToDateString(data.end_time);
        
                        var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                        alert(message);  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                } 
                else
                {
                    alert('Network Fail');
                }
    
                dispatch({type:'Response'});

                Reset();
            }
            catch(error)
            {
                alert('Network Fail');
                dispatch({type:'Response'});
                console.error(error);
            }
        }
    }

  function WriteModal()
  {
    if(state.FAQArray.length === 10)
    {
        alert('10개 이상 등록 할 수 없습니다다. 삭제 후 등록 해주세요');
        return;
    }

    dispatch({type:'UpdateWriteModal', View:true, Type:3});
  }

  
  const closeDetailModalType1 = () => {
    dispatch({type:'UpdateDetailModalType1', View:false, Type:0, No:0});
  }

  const closeWriteModalType = (refresh) => {
    dispatch({type:'UpdateWriteModal', View:false, Type:0});
    if(refresh === true)
    {
        Reset();
        dispatch({type:'RefreshFAQ', Refresh:false});
    }
  }

 
    if(state.FAQFirstRender === false)
    {
        dispatch({type:'FAQFirstRender'});
        Reset();
    } 



  return (
    <div id='Player_Range'>
        <Title DisplayType="6"></Title>
        <div className='search-box'>
            <div className='search_button' onClick={() => WriteModal()}>글쓰기</div>
        </div>
        <div className='faq-box'>
            <div className='faq-box-table'>
                <tr>
                    <th style={{width:"5%"}}>넘버</th>
                    <th style={{width:"10%"}}>제목</th>
                    <th style={{width:"10%"}}>작성일</th>
                    <th style={{width:"10%"}}>삭제</th>
                </tr>
                {Array.from({length:15}).map((_, index)=>(
                    <tr>
                        <td onClick={() => GetFAQClick(index) === true && FAQClick(index)} style={{cursor: GetFAQClick(index) === true ? 'pointer' : 'default', width:"200px", textAlign:"center"}}>{GetFAQNo(index)}</td>
                        <td onClick={() => GetFAQClick(index) === true && FAQClick(index)} style={{cursor: GetFAQClick(index) === true ? 'pointer' : 'default', width:"600px", textAlign:"center"}}>{GetFAQTitle(index)}</td>
                        <td onClick={() => GetFAQClick(index) === true && FAQClick(index)} style={{cursor: GetFAQClick(index) === true ? 'pointer' : 'default', width:"300px", textAlign:"center"}}>{GetFAQRegisterTime(index)}</td>
                        <td>
                        {GetFAQClick(index) === true &&
                          <div className='faq-button-group'>
                            <div className='faq-delete-button' onClick={() => RequestDelete(index)}>삭제</div>
                          </div>}
                        </td>
                    </tr>
                ))}
            </div>
            <div className='faq-box-count-box'>
                <div className='faq-box-count' onClick={() => PrevPage()}><h2>{"<"}이전</h2></div>
                <div className='faq-box-count' onClick={() => ClickViewIndex(GetPageNumber(1))}><h2>{GetPageNumber(1)}</h2></div>
                <div className='faq-box-count' onClick={() => ClickViewIndex(GetPageNumber(2))}><h2>{GetPageNumber(2)}</h2></div>
                <div className='faq-box-count' onClick={() => ClickViewIndex(GetPageNumber(3))}><h2>{GetPageNumber(3)}</h2></div>
                <div className='faq-box-count' onClick={() => ClickViewIndex(GetPageNumber(4))}><h2>{GetPageNumber(4)}</h2></div>
                <div className='faq-box-count' onClick={() => ClickViewIndex(GetPageNumber(5))}><h2>{GetPageNumber(5)}</h2></div>
                <div className='faq-box-count' onClick={() => ClickViewIndex(GetPageNumber(6))}><h2>{GetPageNumber(6)}</h2></div>
                <div className='faq-box-count' onClick={() => ClickViewIndex(GetPageNumber(7))}><h2>{GetPageNumber(7)}</h2></div>
                <div className='faq-box-count' onClick={() => ClickViewIndex(GetPageNumber(8))}><h2>{GetPageNumber(8)}</h2></div>
                <div className='faq-box-count' onClick={() => ClickViewIndex(GetPageNumber(9))}><h2>{GetPageNumber(9)}</h2></div>
                <div className='faq-box-count' onClick={() => ClickViewIndex(GetPageNumber(10))}><h2>{GetPageNumber(10)}</h2></div>
                <div className='faq-box-count' onClick={() => NextPage()}><h2>다음{">"}</h2></div>
            </div>
        </div>
        <DetailModalType1 isOpen={state.detail_modal_type1_open} Type={state.detail_modal_type1_type} No={state.detail_modal_type1_no} onClose={closeDetailModalType1} ></DetailModalType1>
        <WriteModalType isOpen={state.write_modal_open} onClose={closeWriteModalType}></WriteModalType>
    </div>
  );
}

export default FAQ;